import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, HostBinding, Inject, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { interpolateDoubleBracesString } from '@frontend/sports/common/core/utils/string';
import { Store } from '@ngrx/store';

import { ITeaserBetMessages } from '../../../../base/models/betslip-messages';
import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../base/services/betslip-messages-provider.service';
import { IBetslipRootState } from '../../../../base/store/state';
import { BetslipPick } from '../../../../core/picks/betslip-pick';
import { teaserBetStateSelector } from '../../selectors';
import { ITeaserBetState } from '../../state';

@Component({
    selector: 'bs-teaser-bet-header',
    templateUrl: './teaser-bet-header.component.html',
    styleUrls: ['./teaser-bet-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TeaserBetHeaderComponent implements OnInit {
    @Input() pickList: BetslipPick[];
    @Input() isLinear = false;
    teaserInfo: ITeaserBetState;
    title: string;
    teaserBetMessages: ITeaserBetMessages | undefined;
    @HostBinding('class') class = 'header-container';

    private readonly destroyRef = inject(DestroyRef);

    constructor(
        private store: Store<IBetslipRootState>,
        private changeRef: ChangeDetectorRef,
        @Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: IBetslipMessagesProviderService,
    ) {
        const betslipMessages = messageProvider.getMessages();
        this.teaserBetMessages = betslipMessages.teaserBet;
    }

    ngOnInit(): void {
        this.store
            .select(teaserBetStateSelector)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((teaserState) => this.mapTeaserBetInfo(teaserState));
    }

    private mapTeaserBetInfo(teaserState: ITeaserBetState) {
        if (teaserState) {
            let selectedPicksCount = 0;
            for (const [_, value] of Object.entries(teaserState.picks)) {
                if (value?.isSelected) {
                    selectedPicksCount++;
                }
            }

            if (this.teaserBetMessages?.messages.TeaserLegs && this.isLinear) {
                this.title = interpolateDoubleBracesString(this.teaserBetMessages.messages.TeaserLegs, { teasercount: selectedPicksCount });
            }
            this.changeRef.markForCheck();
        }
    }
}
